import { userService } from "../../services/userService";
import { UserProfile, UserProgress } from "../../types/types";
import { injectEndpoints } from ".";

export const userApi = injectEndpoints({
  endpoints: (builder) => ({
    // Get a user by ID
    getUserById: builder.query<UserProfile | null, string>({
      queryFn: async (id) => {
        try {
          const user = await userService.getUserById(id);
          return { data: user };
        } catch (error) {
          return { error };
        }
      },
      providesTags: (result, error, id) => [{ type: "Users", id }], // Tagging the user by ID
    }),

    // Add a user
    addUser: builder.mutation<string, UserProfile>({
      queryFn: async (user) => {
        try {
          const id = await userService.addUser(user);
          return { data: id };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: [{ type: "Users", id: "LIST" }], // Invalidate the Users list cache when adding a new user
    }),

    // Get user progress
    getUserProgress: builder.query<UserProgress | null, string>({
      queryFn: async (userId) => {
        try {
          const progress = await userService.getUserProgress(userId);
          return { data: progress };
        } catch (error) {
          return { error };
        }
      },
      providesTags: (result, error, userId) => [
        { type: "UserProgress" as const, id: userId },
      ],
    }),

    updateLessonProgress: builder.mutation<
      void,
      { userId: string; courseId: string; lessonId: string; score: number }
    >({
      queryFn: async ({ userId, courseId, lessonId, score }) => {
        try {
          await userService.updateLessonProgress(
            userId,
            courseId,
            lessonId,
            new Date().toISOString(),
            score
          );
          return { data: undefined };
        } catch (error) {
          return { error };
        }
      },
      invalidatesTags: (result, error, { userId }) => [
        { type: "UserProgress", id: userId },
      ],
    }),
  }),
});

export const {
  useGetUserByIdQuery,
  useAddUserMutation,
  useGetUserProgressQuery,
  useUpdateLessonProgressMutation,
} = userApi;
